module.exports = __webpack_public_path__ + "assets/ic_tree17.96bf02f3.svg";